import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Conduct & Discipline</h1>
                <p>Home &gt; Conduct & Discipline</p>
            </div>
        </div>
    );
};

export default Hero;
